import { FC } from 'react';
import { Card, HStack, Text } from '@wegroup/design-system';
import TableCheckbox from '@parties/src/features/overview/components/table/TableCheckbox';
import { useYellowhiveFlowsConfigureStore } from '@flows/src/store/zustand/flows-configure/yellowhiveFlowsConfigureStore';
import { SchemaYellowHiveCoverage } from 'wg-api-sdk';

interface Props {
  insuranceId: string;
  coverage: SchemaYellowHiveCoverage;
  isError?: boolean;
  clearError?: () => void;
}

const FlowsConfigureYellowhiveCoverageItem: FC<Props> = ({
  insuranceId,
  coverage,
  isError,
  clearError,
}) => {
  const { coverages, addCoverage, removeCoverage } =
    useYellowhiveFlowsConfigureStore();

  const isSelected = coverages[insuranceId]?.includes(coverage.code) || false;
  const isMandatory = coverage.mandatory;

  const handleSelect = () => {
    // Don't allow interaction with mandatory coverages
    if (isMandatory) return;

    if (isSelected) {
      removeCoverage(insuranceId, coverage.code);
    } else {
      addCoverage(insuranceId, coverage.code);
    }
    if (isError) clearError?.();
  };

  return (
    <Card
      as="button"
      p="4"
      borderColor={
        isError ? 'danger.main' : isSelected ? 'primary.500' : 'gray.50'
      }
      h="100%"
      onClick={() => handleSelect()}
      _hover={{
        borderColor: isSelected ? undefined : 'gray.100',
        boxShadow: isError ? undefined : 'level2',
      }}
      cursor={isMandatory ? 'not-allowed' : 'pointer'}
      opacity={isMandatory ? 0.7 : 1}
      transition="0.1s"
    >
      <HStack spacing="3">
        <Text flexGrow="1">{coverage.name}</Text>
        <TableCheckbox
          isChecked={isSelected}
          onChange={() => null}
          isDisabled={isMandatory}
        />
      </HStack>
    </Card>
  );
};

export default FlowsConfigureYellowhiveCoverageItem;
